import { Component, inject } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { DownloadProgressService } from './download-progress.service';

@Component({
  selector: 'ume-download-progress-toast',
  imports: [MatProgressSpinner],
  templateUrl: './download-progress-toast.component.html',
  styleUrl: './download-progress-toast.component.scss',
})
export class DownloadProgressToastComponent {
  protected readonly service = inject(DownloadProgressService);
}
